/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-channel.stache';
import can from 'can';
import deviceUtil from 'scripts/utils/device';
import liveVideoService from 'scripts/services/live-video-service';

const liveVideoPopOutUrl = window.globalSettings.pagePaths.liveVideoPopOut;
const inWebView = window.globalSettings.inWebView;

Component.extend({
    tag: 'live-channel',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            liveVideoCard: {
                Type: can.Map,
                Value: null
            },
            isActive: {
                type: 'boolean',
                value: false
            },
            playerTags: {
                type: 'string',
                get() {
                    const playerTags = this.attr('liveVideoCard.playerTagGroups') || [];
                    
                    return playerTags.map(groupTag => groupTag.map(playerTag => playerTag.title).join(', '));
                }
            }
        },
        closeLiveVideoPlayer() {
            this.attr('isActive', false);
        },
        onVideoClick(event, videoId) {
            if(deviceUtil.isMobile && !inWebView) {
                this.attr('isActive', true);
            } else {
                liveVideoService.openWindow(videoId);
            }
        }
    }
});